import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { useIsMobile } from "../utils/useIsMobile";
import { cacheClear } from "../utils/dataCache";

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const handleLogout = () => {
    localStorage.removeItem("token");
    cacheClear();
    navigate("/login", { replace: true });
  };

  return (
    <div className="app-shell-bg">
      <Sidebar onLogout={handleLogout} />
      <div className="app-shell-panel" style={{ flex: 1, minWidth: 0 }}>
        <Navbar />
        <main
          className="soft-scroll"
          style={{
            padding: isMobile ? 16 : 24,
            overflowY: "auto",
            flex: 1,
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
